import { render, staticRenderFns } from "./two-factor.vue?vue&type=template&id=6551158a"
import script from "./two-factor.vue?vue&type=script&lang=js"
export * from "./two-factor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports